<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "oo-wrapper"
};
</script>

<style>
</style>